module.exports = __webpack_public_path__ + "img/remosion-masa.5b085c6e.jpg";